<script>
  import Cta from "./Cta.svelte";
  import apiData from "api-client";

  import { onMount } from "svelte";
  import {DARK_THEME} from "../utils/utils"
  import {getNameLabel} from "../utils/name"
  import {getVisualComponent} from "../utils/visual"

  export let theme;
  export let tierLogos = {};

  const tiers = ["Connoisseur", "Expert", "Ambassador"];
  let componentList = {};

  let tierIndex = 2;

  $: tierComponent = componentList[tiers[tierIndex]];
  $: tierLogoName = tiers[tierIndex];

  let content;
  let user;
  let addresses = [];

  let promises = getData();

  async function getData() {
    try{
      var res = await Promise.all([
        apiData.fetchLocalization("Subscriber"),
        apiData.fetchCustomer()
      ])
    }catch(e){
      console.log('Discover init error',e);
    }
    content = res[0];
    user = res[1];

    try{
      if (content && content.name && content.name === 'lastname') {
        addresses = await apiData.fetchAddresses()
      }
    }catch(e){
      console.log(e);
    }

    componentList.Ambassador = await getVisualComponent(tierLogos)["Ambassador"]()

    return true;
  }

  function nameLabel() {
    return getNameLabel(content.title, user, addresses[0], content.name)
  }

</script>

{#await promises then res}
  <div
    class="loyaltyBanner"
    class:darkTheme={theme === DARK_THEME}
    class:lightTheme={theme !== DARK_THEME} >
    <h2 class="loyaltyTitle">
      {@html nameLabel()}
    </h2>
    <p class="loyaltyLead">
      {@html content.description}
    </p>
    <div class="loyaltyLinks">
      {#each content.buttons as button, idx (button.label)}
        <Cta
          link={button.url}
          role={button.render}
          action={button.action}
          screenName="discover"
          trackingLabel={button.trackingLabel}
          label={button.label}
        />
      {/each}
    </div>
    <div class="loyaltyFocus">
      <div class="loyaltyLogo">
        <svelte:component
          height="53"
          this={tierComponent}
          className={'discoverLogo discoverLogo' + tierLogoName} />
      </div>
    </div>
  </div>
{/await}

<style>
  .darkTheme.loyaltyBanner {
    color: #000;
    background-color: #fff;
  }
  .lightTheme.loyaltyBanner {
    color: #fff;
    background-color: #000;
  }

  .loyaltyBanner {
    background-color: #fff;
    color: #000;
    padding: 30px;
    letter-spacing: 1px;
    line-height: 24px;
    font-size: 16px;
    font-weight: 300;
    position: relative;
  }
  .loyaltyTitle {
    color: inherit;
    font-weight: 900;
    font-size: 18px;
    text-transform: uppercase;
    letter-spacing: 3px;
    line-height: 24px;
    max-width: 60%;
  }
  .loyaltyLead {
    padding-top: 16px;
    margin-top: 0;
  }
  .loyaltyFocus {
    text-align: center;
  }

  @media (min-width: 769px) {
    .loyaltyBanner {
      padding: 24px 0 24px 32px;
    }
    .loyaltyLinks {
      padding-top: 24px;
    }
    .loyaltyFocus {
      margin: 0 21px 0 0;
      position: absolute;
      right: 0;
      top: calc(50% - 25px);
      width: 328px;
    }
    .loyaltyLead {
      max-width: 58%;
    }
    :global(.discoverLogo) {
      height: 53px;
      margin-bottom: 10px;
    }
    .loyaltyLogo {
      height: 50px;
    }
  }
  @media (max-width: 768px) {
    .loyaltyBanner {
      padding: 24px 15px 24px 15px;
      text-align: center;
    }
    .loyaltyTitle {
      max-width: none;
    }
    .loyaltyLead {
      padding-top: 8px;
      font-size: 14px;
      text-align: center;
      max-width: none;
    }
    .loyaltyLinks {
      padding-top: 24px;
      text-align: center;
    }
    .loyaltyFocus {
      margin-top: 23px;
    }
    :global(.discoverLogo) {
      height: 32px;
      margin-bottom: 0;
    }
    .loyaltyLogo {
      height: none;
    }
  }
</style>
